import axiosInstance from "./api_helper";

const refundService = {
    search: async ({ query = '', page = 0, size = 10 }) => {
        return axiosInstance.get('/api/retours-client/search', {
            params: { query, page, size }
        });
    },
    delete: async (id) => {
        return axiosInstance.delete(`/api/retours-client/${id}`);
    },
    save: async (refund) => {
        return axiosInstance.post(`/api/retours-client`, JSON.stringify(refund));
    },
    update: async (payload) => {
        return axiosInstance.put(`/api/retours-client/${payload.id}`, JSON.stringify(payload.refund));
    },

};
export default refundService;
